<template>
  <div>
    <div id="principal" class="w3-col w3-white w3-margin-top w3-padding">
      <span class="w3-button">{{titulo}}</span>

      <button
        class="w3-button w3-green w3-left"
        @click="mostrarModalEnderecosEntrega()">
        <i class="fas fa-plus"></i>
      </button>

      <div class="w3-col w3-margin-top">
        <p class="texto-cinza w3-center" v-show="enderecos.length == 0">
          <span>Nenhum endereço cadastrado</span>
        </p>
      </div>

      <div class="w3-col" v-show="enderecos.length > 0" v-cloak>
        <div
          :key="index" v-for="(endereco, index) in enderecos"
          class="w3-col card-item w3-border w3-padding-small"
          style="cursor: pointer;">

          <div class="w3-col">
            <strong v-if="endereco.tipo_imovel">
              <span>{{getDescricaoTipoImovel(endereco.tipo_imovel)}}</span>
            </strong>

            <strong v-if="endereco.tipo_acesso_imovel != 'N'">
              <span> - {{getDescricaoTipoAcessoImovel(endereco.tipo_acesso_imovel)}}</span>  
            </strong>

            <span v-if="(endereco.andar) && (endereco.andar > 0)">
              <span> - {{endereco.andar}}º andar</span>
            </span>
          </div>

          <div class="w3-col">
            <span>{{getDescricaoEndereco(endereco)}}</span>
          </div>

          <div class="w3-col">
            <span v-if="endereco.inscricao_estadual">
              <span>IE: {{endereco.inscricao_estadual}}</span>
            </span>
          </div>

          <div class="w3-col">
            <span v-if="endereco.inscricao_municipal">
              <span>IM: {{endereco.inscricao_municipal}}</span>
            </span>
          </div>

          <div class="w3-col">
            <span v-if="endereco.codigo_propriedade_indea">
              <span>Código INDEA: {{endereco.codigo_propriedade_indea}}</span>
            </span>
          </div>

          <div class="w3-col">
            <div class="w3-right">
              <span @click="alterarEndereco(index)">(<span class="link">alterar</span>)</span>
              <span>|</span>
              <span @click="excluirEndereco(index)">(<span class="link">excluir</span>)</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="coleta_visivel" class="w3-modal" style="display: block">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <span
            @click="fechar()"
            class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

          <h5 class="w3-left w3-col m12 titulo" v-cloak>
            <b class="texto-vermelho">
              <i class="fa fa-map fa-fw"></i>
              <span>{{titulo_tela_coleta}}</span>
            </b>
          </h5>
        </header>

        <div v-if="parUtilizaControleCep == 'S'" class="w3-row-padding">
          <div class="w3-container w3-col w3-margin-top">
            <strong class="w3-col w3-block w3-padding w3-light-blue">Principal</strong>
          </div>

          <div class="w3-col s12 m6">
            <label>CEP</label>

            <div class="w3-col">
              <input
                id="campoCEP"
                type="text"
                ref="campoCEP"
                class="w3-input w3-border w3-col"
                style="max-width: 85%"
                v-model="cep"
                v-mask="'#####-###'"
                v-on:keyup.enter="buscarCep(cep)"
                :disabled="selecionou_cep"/>

              <button
                class="w3-col w3-button w3-blue"
                style="max-width: 15%;"
                @click="pesquisarCep()"
                v-if="!selecionou_cep">
                <i class="fas fa-search"></i>
              </button>

              <button
                class="w3-col w3-button w3-white w3-border"
                style="max-width: 15%;"
                @click="limparCep()"
                v-if="selecionou_cep">
                <span>&times;</span>
              </button>
            </div>
          </div>

          <div class="w3-col s12 m6">
            <label>Logradouro</label>
            <input
              type="text"
              ref="campoLogradouro"
              class="w3-input w3-border uppercase"
              id="logradouro"
              maxlength="50"
              v-model="logradouro"
              :disabled="!editar_logradouro">
          </div>

          <div class="w3-col s12 m6">
            <label>Complemento</label>
            <input
              type="text"
              ref="campoComplemento"
              class="w3-input w3-border uppercase"
              maxlength="50"
              v-model="complemento">
          </div>

          <div class="w3-col s12 m6">
            <label>Ponto de referência</label>
            <input
              type="text"
              ref="campoPontoReferencia"
              class="w3-input w3-border uppercase"
              maxlength="200"
              v-model="ponto_referencia">
          </div>

          <div class="w3-col s12 m6">
            <frame-bairro
              ref="frBairro"
              :bairroSelecionado="bairro_selecionado">
            </frame-bairro>
          </div>

          <div class="w3-container w3-col w3-margin-top">
            <strong class="w3-col w3-block w3-padding w3-light-blue">Imóvel</strong>
          </div>

          <div class="w3-col s12 m6">
            <label>Tipo de imóvel</label>
            <select
              ref="campoTipoImovel"
              class="w3-select w3-border"
              v-model="tipo_imovel"
              @change="selecionarTipoImovel()">

              <option
                :key="tipo.sigla"
                v-for="tipo in tipos_imoveis"
                :value="tipo.sigla">
                <span>{{tipo.descricao}}</span>
              </option>
            </select>
          </div>

          <div v-if="editar_tipo_acesso_imovel" class="w3-col s12 m6">
            <label>Tipo de acesso imóvel</label>
            <select
              class="w3-select w3-border"
              v-model="tipo_acesso_imovel"
              @change="selecionarTipoAcessoImovel()">

              <option
                :key="tipo.sigla"
                v-for="tipo in tipos_acessos_imoveis"
                :value="tipo.sigla">
                <span>{{tipo.descricao}}</span>
              </option>
            </select>
          </div>

          <div v-if="editar_andar" class="w3-col s12 m6">
            <label>Andar</label>
            <input
              type="text"
              class="w3-input w3-border"
              ref="campoAndar"
              v-model="andar">
          </div>
        </div>

        <div v-if="parUtilizaControleCep == 'N'">
          <div class="w3-container w3-col w3-margin-top">
            <strong class="w3-col w3-block w3-padding w3-light-blue">Principal</strong>
          </div>

          <div class="w3-container w3-col s12 m6">
            <label>Logradouro</label>
            <input
              type="text"
              ref="campoLogradouroNormal"
              class="w3-input w3-border uppercase"
              id="logradouro"
              maxlength="50"
              v-model="logradouro">
          </div>

          <div class="w3-container w3-col s12 m6">
            <label>Complemento</label>
            <input
              type="text"
              ref="campoComplementoNormal"
              class="w3-input w3-border uppercase"
              maxlength="50"
              v-model="complemento">
          </div>

          <div class="w3-container w3-col s12 m6">
            <frame-bairro
              ref="frBairro"
              :bairroSelecionado="bairro_selecionado">
            </frame-bairro>
          </div>

          <div class="w3-container w3-col s12 m6">
            <label>Ponto de referência</label>
            <input
              type="text"
              ref="campoPontoReferenciaNormal"
              class="w3-input w3-border uppercase"
              maxlength="200"
              v-model="ponto_referencia">
          </div>

          <div class="w3-container w3-col s12 m6">
            <label>CEP</label>
            <input
              type="text"
              ref="campoCEPNormal"
              class="w3-input w3-border"
              v-model="cep"
              v-mask="'#####-###'"
              onClick="this.select();"
              v-on:blur="carregarCep(cep)"
              v-on:keyup.enter="carregarCep(cep)">
          </div>

          <div class="w3-container w3-col w3-margin-top">
            <strong class="w3-col w3-block w3-padding w3-light-blue">Imovel</strong>
          </div>

          <div class="w3-col">
            <div class="w3-container w3-col s12 m6">
              <label>Tipo de imóvel</label>
              <select
                class="w3-select w3-border"
                ref="campoTipoImovelNormal"
                v-model="tipo_imovel"
                @change="selecionarTipoImovel()">

                <option
                  :key="tipo.sigla"
                  v-for="tipo in tipos_imoveis"
                  :value="tipo.sigla">
                  <span>{{tipo.descricao}}</span>
                </option>
              </select>
            </div>

            <div v-if="editar_tipo_acesso_imovel" class="w3-container w3-col s12 m6">
              <label>Tipo de acesso imóvel</label>
              <select
                class="w3-select w3-border"
                ref="campoTipoAcessoImovel"
                v-model="tipo_acesso_imovel"
                @change="selecionarTipoAcessoImovel()">

                <option
                  :key="tipo.sigla"
                  v-for="tipo in tipos_acessos_imoveis"
                  :value="tipo.sigla">
                  <span>{{tipo.descricao}}</span>
                </option>
              </select>
            </div>
            
            <div v-if="editar_andar" class="w3-container w3-col s12 m6">
              <label>Andar</label>
              <input
                type="text"
                class="w3-input w3-border"
                ref="campoAndarNormal"
                v-model="andar">
            </div>
          </div>
        </div>

        <div class="w3-container w3-col w3-margin-top">
          <strong class="w3-col w3-block w3-padding w3-light-blue">Registros</strong>
        </div>

        <div
          v-if="em(tipo_cliente, ['O', 'U', 'A'])"
          class="w3-container w3-col s12 m6">

          <label>Inscrição estadual</label>
          <input
            type="text"
            ref="campoInscricaoEstadual"
            class="w3-input w3-border uppercase"
            v-model="inscricao_estadual">
        </div>

        <div class="w3-container w3-col s12 m6">
          <label>Inscrição municipal</label>
          <input
            type="text"
            ref="campoInscricaoMunicipal"
            class="w3-input w3-border uppercase"
            v-model="inscricao_municipal">
        </div>

        <div
          class="w3-container w3-col s12 m6"
          v-if="parReceituarioUtilizaReceituario == 'S'">
          <label>Código propriedade INDEA</label>
          <input
            type="text"
            ref="campoCodigoPropriedadeIndea"
            class="w3-input w3-border uppercase"
            v-model="codigo_propriedade_indea">
        </div>

        <footer class="w3-container conteudo-centralizado">
          <button
            class="w3-btn w3-theme"
            style="margin-top: 10px; margin-bottom: 10px;"
            @click="confirmar()">
            <span>Confirmar</span>
          </button>
        </footer>

      </div>
    </div>

    <pesquisa-CEPs 
      ref="pesquisaCeps"
      @confirmar="confirmarCep">
    </pesquisa-CEPs>

  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RCep from '@/components/Rest/RCep';
  import FrameBairro from '@/components/Frames/FrameBairro';
  import PesquisaCEPs from '@/components/Pesquisas/PesquisaCEPs';

  export default {
    name: 'FrameEnderecosEntrega',

    components: {
      FrameBairro,
      PesquisaCEPs
    },

    props: {
      parUtilizaControleCep: {
        type: String,
        default: 'S',
        required: true
      },

      parReceituarioUtilizaReceituario: {
        type: String,
        default: 'N',
        required: true
      },

      parReceituarioOrgaoRegulamentador: {
        type: String,
        default: 'N',
        required: true
      },

      titulo: {
        type: String,
        default: 'Endereços de entrega',
        required: false
      },

      enderecosEntregaCarregar: {
        type: Array,
        default: [],
        required: false
      }
    },

    data() {
      return {
        enderecos: [],

        titulo_tela_coleta: 'Inserir Endereço de Entrega',
        coleta_visivel: false,
        indice_edicao: -1,

        tipo_cliente: '',

        cep: '',
        selecionou_cep: false,
        cep_selecionado: undefined,

        logradouro: '',
        editar_logradouro: false,

        andar: '',
        editar_andar: false,
        
        tipo_acesso_imovel: '',
        editar_tipo_acesso_imovel: false,
        
        complemento: '',
        bairro_selecionado: {},
        ponto_referencia: '',
        tipo_imovel: 'NIN',
        inscricao_estadual: '',
        inscricao_municipal: '',
        codigo_propriedade_indea: '',

        tipos_acessos_imoveis: [
          {
            sigla: 'T',
            descricao: 'Térreo'
          },
          {
            sigla: 'L',
            descricao: 'Elevador'
          },
          {
            sigla: 'E',
            descricao: 'Escada'
          },
          {
            sigla: 'N',
            descricao: 'Nenhum'
          }
        ],

        tipos_imoveis: [
          {
            sigla: 'NIN',
            descricao: 'Não informado'
          },
          {
            sigla: 'APH',
            descricao: 'Apart Hotel'
          },
          {
            sigla: 'APA',
            descricao: 'Apartamento'
          },
          {
            sigla: 'CCO',
            descricao: 'Casa comercial'
          },
          {
            sigla: 'CAC',
            descricao: 'Casa em condomínio'
          },
          {
            sigla: 'CAS',
            descricao: 'Casa'
          },
          {
            sigla: 'FAZ',
            descricao: 'Fazenda/chácara/sítio'
          },
          {
            sigla: 'GAL',
            descricao: 'Galpão'
          },
         {
            sigla: 'GAR',
            descricao: 'Garagem'
          },
          {
            sigla: 'LOJ',
            descricao: 'Loja'
          },
          {
            sigla: 'LOT',
            descricao: 'Lote'
          },
          {
            sigla: 'PRE',
            descricao: 'Prédio'
          },
          {
            sigla: 'QUI',
            descricao: 'Quintinete'
          },
          {
            sigla: 'SAL',
            descricao: 'Sala comercial'
          },
          {
            sigla: 'SOB',
            descricao: 'Sobrado'
          },
        ]
      }
    },

    methods: {
      setarFocoPrimeiroCampo() {
        if (this.parUtilizaControleCep == 'S') {
          this.$nextTick(() =>this.$refs.campoCEP.focus());
        }
        else {
          this.$nextTick(() =>this.$refs.campoLogradouroNormal.focus());
        }
      },

      mostrarModalEnderecosEntrega() {
        this.coleta_visivel = true;
        this.limparColetaDados();
        this.setarFocoPrimeiroCampo();
      },

      carregarBairro(bairro_id, nome_bairro, cidade_id, nome_cidade, estado_id) {
        
      },

      pesquisarCep() {
        if ((!this.selecionou_cep) && (this.cep) && (Biblioteca.numeros(this.cep).length == 8)) {
          this.buscarCep(this.cep);
        }
        else {
          this.abrirPesquisaCep();
        }
      },

      confirmarCep(cep){
        this.buscarCep(cep.cep_formatado != null ? cep.cep_formatado : cep.cep_id);
      },

      abrirPesquisaCep() {
        this.$refs.pesquisaCeps.abrir();
      },

      getCampoLogradouro() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoLogradouro;
        }
        else {
          return this.$refs.campoLogradouroNormal;
        }
      },

      getCampoCep() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoCEP;
        }
        else {
          return this.$refs.campoCEPNormal;
        }
      },

      setCampoCep(cep) {
        if (this.parUtilizaControleCep == 'S') {
          this.cep = cep;
          return this.$refs.campoCEP = cep;
        }
        else {
          return this.$refs.campoCEPNormal = cep;
        }
      },

      getCampoComplemento() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoComplemento;
        }
        else {
          return this.$refs.campoComplementoNormal;
        }
      },

      getCampoPontoReferencia() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoPontoReferencia;
        }
        else {
          return this.$refs.campoPontoReferenciaNormal;
        }
      },
      
      getCampoTipoImovel() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoTipoImovel;
        }
        else {
          return this.$refs.campoTipoImovelNormal;
        }
      },

      getCampoAndar() {
        if (this.parUtilizaControleCep == 'S') {
          return this.$refs.campoAndar;
        }
        else {
          return this.$refs.campoAndarNormal;
        }
      },

      selecionarTipoAcessoImovel() {
        this.editar_andar = Biblioteca.em(this.tipo_acesso_imovel, ['E', 'L']);
        if (this.tipo_acesso_imovel == 'T') { 
          this.andar = '';
        }
      },

      selecionarTipoImovel() {
        this.editar_tipo_acesso_imovel = Biblioteca.em(
          this.tipo_imovel,
          ['APA', 'APH', 'SAL', 'PRE', 'QUI', 'SOB']
        );

        if ((!this.editar_tipo_acesso_imovel) || (this.tipo_imovel == 'NIN')) {
          this.tipo_acesso_imovel = 'N';
          this.andar = '';
        }

        this.selecionarTipoAcessoImovel();
      },
    
      verificarDados() {
        if (this.parUtilizaControleCep == 'S') {        
          if (!this.selecionou_cep) {
            toastr.error('Informe o CEP!');
            this.$nextTick(() => this.getCampoCep().focus());          
            return false;
          }

          if (Biblioteca.stringVazia(this.complemento)) {
            toastr.error('Informe o complemento!');
            this.$nextTick(() => this.getCampoComplemento().focus());
            return false;
          }

          if (this.complemento.length > 50) {
            toastr.error('O complemento deve ter no máximo 50 caracteres!');
            this.$nextTick(() => this.getCampoComplemento().focus());
            return false;
          }

          if (Biblioteca.stringVazia(this.ponto_referencia)) {
            toastr.error('Informe o ponto de referência!');
            this.$nextTick(() => this.getCampoPontoReferencia().focus());          
            return false;
          }

          if (this.ponto_referencia.length > 100) {
            toastr.error('O ponto de referência deve ter no máximo 100 caracteres!');
            this.$nextTick(() => this.getCampoPontoReferencia().focus());
            return false;
          }
        }
        else {
          if (Biblioteca.stringVazia(this.logradouro)) {
            toastr.error('Informe o logradouro!');
            this.$nextTick(() => this.getCampoLogradouro().focus());
            return false;
          }

          if (this.logradouro.length > 50) {
            toastr.error('O logradouro deve ter no máximo 50 caracteres!');
            this.$nextTick(() => this.getCampoLogradouro().focus());
            return false;
          }

          if (Biblioteca.stringVazia(this.complemento)) {
            toastr.error('Informe o complemento!');
            this.$nextTick(() => this.getCampoComplemento().focus());
            return false;
          }

          if (this.complemento.length > 50) {
            toastr.error('O complemento deve ter no máximo 50 caracteres!');
            this.$nextTick(() => this.getCampoComplemento().focus());
            return false;
          }

          let bairro_selecionado = this.$refs.frBairro.selecao();
          if ((!bairro_selecionado) || (!bairro_selecionado.bairro_id)) {
            toastr.error('Selecione o bairro!');
            return false;
          }

          if (Biblioteca.stringVazia(this.ponto_referencia)) {
            toastr.error('Informe o ponto de referência!');
            this.$nextTick(() => this.getCampoPontoReferencia().focus());          
            return false;
          }

          if (this.ponto_referencia.length > 100) {
            toastr.error('O ponto de referência deve ter no máximo 100 caracteres!');
            this.$nextTick(() => this.getCampoPontoReferencia().focus());
            return false;
          }

          if (Biblioteca.numeros(this.cep).length != 8) {
            toastr.error('Informe um CEP válido!');
            this.$nextTick(() => this.getCampoCep().focus());          
            return false;
          }
        }

        if (this.tipo_imovel == 'NIN') {
          toastr.error('Informe o tipo de imóvel!');
          this.$nextTick(() => this.getCampoTipoImovel().focus());          
          return false;
        }

        if (
          (this.tipo_acesso_imovel == 'N') &&
          (
            Biblioteca.em(
              this.tipo_imovel,
              ['APA', 'APH', 'SAL', 'PRE', 'QUI', 'SOB']
            )
          )
        ) {
          toastr.error('Para esse tipo de imóvel, informe o tipo de acesso!');
          this.$nextTick(() => this.$refs.campoTipoAcessoImovel.focus());          
          return false;
        }

        if (
          (Biblioteca.valorInt(this.andar) <= 0) &&
          (Biblioteca.em(this.tipo_acesso_imovel, ['L', 'E']))
        ) {
          toastr.error('Informe o andar para este tipo de acesso a imóvel!');
          this.$nextTick(() => this.getCampoAndar().focus());          
          return false;
        }

        if (this.andar > 99) {
          toastr.error('O andar máximo é 99!');
          this.$nextTick(() => this.getCampoAndar().focus());
          return false;
        }

        return true;
      },

      fechar() {
        this.coleta_visivel = false;
      },

      carregarCep(cep) {
        this.cep_selecionado = JSON.parse(JSON.stringify(cep));

        this.setCampoCep(this.cep_selecionado.cep_formatado);

        if (typeof this.cep_selecionado === "object") {
          this.setCampoCep(this.cep_selecionado.cep_formatado);
          this.logradouro = this.cep_selecionado.logradouro;
        } else {
          this.setCampoCep(this.cep_selecionado);
        }
        
        if (Biblioteca.stringVazia(this.logradouro)) {
          this.editar_logradouro = true;
          this.$nextTick(() => this.getCampoLogradouro().focus());
        }
        else {
          this.editar_logradouro = false;
          this.$nextTick(() => this.getCampoComplemento().focus());
        }

        let bairro_id = Biblioteca.valorInt(this.cep_selecionado.bairro_id);
        let cidade_id = Biblioteca.valorInt(this.cep_selecionado.cidade_id);
        if (bairro_id > 0) {
          this.$refs.frBairro.inserirDadoPorChave(bairro_id);
          this.$refs.frBairro.somenteLeitura = "S";
        } else if (cidade_id > 0) 
          this.$refs.frBairro.cidadeSelecionada = cidade_id; 

        this.selecionou_cep = true;
      },

      limparCep() {
        this.cep = '';
        this.cep_selecionado = undefined;
        this.selecionou_cep = false;
        this.$refs.frBairro.limparDados();

        if (!this.editar_logradouro) {
          this.logradouro = '';
        }

        this.$nextTick(() => this.$refs.campoCEP.focus());
      },

      confirmar() {
        if (!this.verificarDados()) {
          return;
        }

        let bairro_selecionado = this.$refs.frBairro.selecao();
        
        let objeto = {
          cep: this.cep,
          objeto_cep: this.cep_selecionado,
          logradouro: this.logradouro.toUpperCase(),
          andar: this.andar,
          tipo_acesso_imovel: this.tipo_acesso_imovel,
          complemento: this.complemento.toUpperCase(),
          bairro: bairro_selecionado,
          ponto_referencia: this.ponto_referencia.toUpperCase(),
          tipo_imovel: this.tipo_imovel,
          inscricao_estadual: this.inscricao_estadual,
          inscricao_municipal: this.inscricao_municipal,
          codigo_propriedade_indea: this.codigo_propriedade_indea
        }

        if (this.indice_edicao == -1) {
          this.enderecos.push(objeto)
        }
        else {
          this.enderecos[this.indice_edicao] = JSON.parse(JSON.stringify(objeto));
        }

        this.limparColetaDados();
        this.coleta_visivel = false;

        this.$emit('confirmar', this.enderecos);
      },

      carregar(enderecos_carregar) {
        if (!enderecos_carregar) {
          this.enderecos = [];
          return;  
        }

        this.enderecos = JSON.parse(JSON.stringify(enderecos_carregar));
      },

      limparColetaDados() {
        this.indice_edicao = -1;

        this.cep = '';
        this.selecionou_cep = false;
        this.cep_selecionado = undefined;

        this.logradouro = '';
        this.editar_logradouro = false;

        this.andar = '';
        this.editar_andar = false;
        
        this.tipo_acesso_imovel = '';
        this.editar_tipo_acesso_imovel = false;
        
        this.complemento = '';
        this.bairro_selecionado = {};
        this.ponto_referencia = '';
        this.tipo_imovel = 'NIN';
        this.inscricao_estadual = '';
        this.inscricao_municipal = '';
        this.codigo_propriedade_indea = '';
      },

      async buscarCep(cep_pesquisa) {  
        if (Biblioteca.numeros(cep_pesquisa).length != 8) {
          toastr.error('Informe um CEP válido!');
          this.$nextTick(() =>this.$refs.campoCEP.focus());
          return;          
        }

        this.processando = true;

        let parametros = {
          cep_id: cep_pesquisa
        }

        try {
          let retorno = await RCep.buscarCepPorId(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.carregarCep(retorno.dados);
          this.processando = false;
        }
        catch(e) {
          toastr.error(e.message);
          this.processando = false;
        }
      },

      getEnderecosEntrega() {
        for (let i = 0; i < this.enderecos.length; i++) {
          this.enderecos[i].ordem = 0;
        }

        return this.enderecos;
      },

      getDescricaoEndereco(endereco) {
        let retorno = endereco.logradouro;
        
        if (endereco.complemento) {
          retorno += ', ' + endereco.complemento;
        }

        if (endereco.ponto_referencia) {
          retorno += ' - ' + endereco.ponto_referencia;
        }

        if (endereco.bairro) {
          retorno += (
            ' - ' + endereco.bairro.nome_bairro + 
            ' - ' + endereco.bairro.nome_cidade + 
            '/' + endereco.bairro.estado_id
          );
        }

        if (endereco.cep) {
          retorno += ' - ' + endereco.cep;
        }

        return retorno;
      },

      getDescricaoTipoImovel(sigla) {
        for (let i = 0; i < this.tipos_imoveis.length; i++) {
          if (this.tipos_imoveis[i].sigla == sigla) {
            return this.tipos_imoveis[i].descricao;
          }
        }

        return 'Tipo de imóvel indefinido';
      },

      getDescricaoTipoAcessoImovel(sigla) {
        for (let i = 0; i < this.tipos_acessos_imoveis.length; i++) {
          if (this.tipos_acessos_imoveis[i].sigla == sigla) {
            return this.tipos_acessos_imoveis[i].descricao;
          }
        }

        return 'Tipo de acesso ao imóvel indefinido';
      },

      async alterarEndereco(index) {
        this.limparColetaDados();

        this.coleta_visivel = true;
        this.indice_edicao = index;


        this.cep = this.enderecos[index].cep;
        this.logradouro = this.enderecos[index].logradouro;

        if (this.enderecos[index].bairro) {
          this.bairro_selecionado = JSON.parse(
            JSON.stringify(this.enderecos[index].bairro)
          )

          this.$nextTick(() => this.$refs.frBairro.somenteLeitura = "S");
        }
        
        this.selecionou_cep = true;

        this.complemento = this.enderecos[index].complemento;
        this.ponto_referencia = this.enderecos[index].ponto_referencia;

        this.inscricao_estadual = this.enderecos[index].inscricao_estadual;
        this.inscricao_municipal = this.enderecos[index].inscricao_municipal;
        this.codigo_propriedade_indea = this.enderecos[index].codigo_propriedade_indea;

        this.tipo_imovel = this.enderecos[index].tipo_imovel;
        this.selecionarTipoImovel();

        if (this.editar_tipo_acesso_imovel) {
          this.tipo_acesso_imovel = this.enderecos[index].tipo_acesso_imovel;
          this.selecionarTipoAcessoImovel();

          if (this.editar_andar) {
            this.andar = this.enderecos[index].andar;
          }
        }

        this.setarFocoPrimeiroCampo();
      },

      excluirEndereco(index) {
        this.enderecos.splice(index, 1);
        this.$emit('confirmar', this.enderecos);
      },

      aplicarMascara(numeros, mascara) {
        return Biblioteca.aplicarMascara(numeros, mascara);
      },

      em(base, vetor) {
        return Biblioteca.em(base, vetor);
      }
    },

    created() {
      if ((!this.enderecosEntregaCarregar) || (this.enderecosEntregaCarregar.length <= 0)) {
        return;
      }

      this.enderecos = JSON.parse(JSON.stringify(this.enderecosEntregaCarregar));
    }
  }
</script>

<style scoped>
  #principal {
    border: 1px solid #aaaaaa;
    border-radius: 10px;
  }

  .link {
    color: #9c1d1c;
    text-decoration: underline;
  }

  #campoCEP {
    background-color: #c2ebd6;
    color: #000000;
    font-weight: bold;
  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameEnderecosEntrega.vue